module.exports = __webpack_public_path__ + "static/media/sandwich.4821fa6a.svg";